<template>
	<div class="flex flex-row items-center text-18">
		<app-icon v-if="item.isTakeAwayOrder" icon="greeting" />
		<transport-type-icon v-else :transport-type="item['courierUser']['transportType']" />
		<app-icon icon="phone" v-if="item['createdByUser'] && item['createdByUser'].id !== 0" />
		<app-icon icon="clock" v-if="item.isScheduledOrder" />
		<app-icon
			class="text-lg pl-1 cursor-pointer"
			v-if="item['addressDetails'] !== '' || (item.description && item.description !== '')"
			icon="envelope"
			@click="$emit('onNotesClick', item)"
		/>
		<span
			class="red-pointer"
			v-if="deliveryTimeOrder(item['registrationtime'], item['deliverytime'] + 10, item.status)"
		></span>
	</div>
</template>

<script>
	import RouteNames from '@/router/names';
	import moment from 'moment';
	import AppIcon from '@/components/app/AppIcon';
	import TransportTypeIcon from '@/components/couriers/TransportTypeIcon';

	export default {
		name: 'OrderTypeSection',
		props: ['item'],
		components: {
			TransportTypeIcon,
			AppIcon,
		},
		data: () => ({
			RouteNames,
		}),
		methods: {
			deliveryTimeOrder(registrationTime, deliveryTime, status) {
				const nowTime = moment().format('HH:mm');
				const orderTime = moment(registrationTime)
					.add(deliveryTime, 'm')
					.format('HH:mm');
				return nowTime > orderTime && status !== 'DELIVERED' && status !== 'REJECTED';
			},
		},
	};
</script>
